import axios from "axios";
import { useEffect, useRef, useState } from "react";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:5000";

export const API_BASE = API_URL;

const apiClient = axios.create({
  baseURL: `${API_URL}/api`,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("hb_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Resolve a possibly-relative file URL (e.g. "/uploads/videos/x.mp4") returned
// by the API into an absolute URL pointing at the backend host.
export const resolveFileUrl = (url) => {
  if (!url) return "";
  if (/^https?:\/\//i.test(url)) return url;
  return `${API_URL}${url}`;
};

// Simple, dependency-free GET hook (plain axios + useState/useEffect).
// Avoids RTK Query's store-subscription entirely for public read-only sections.
export const useApiQuery = (path) => {
  const [state, setState] = useState({ data: undefined, isLoading: true, isError: false });
  const [reloadTick, setReloadTick] = useState(0);
  const pathRef = useRef(path);
  pathRef.current = path;

  useEffect(() => {
    let cancelled = false;
    setState((s) => ({ data: s.data, isLoading: true, isError: false }));

    apiClient
      .get(pathRef.current)
      .then((res) => {
        if (!cancelled) setState({ data: res.data, isLoading: false, isError: false });
      })
      .catch(() => {
        if (!cancelled) setState({ data: undefined, isLoading: false, isError: true });
      });

    return () => {
      cancelled = true;
    };
  }, [path, reloadTick]);

  const refetch = () => setReloadTick((t) => t + 1);

  return { ...state, refetch };
};

export default apiClient;
